import { ParseExportFailure } from "../utils/ParseExportFailure";
import { QRFC } from "./QRFC";

export class QCreatePubDoc extends QRFC {
  constructor() {
    //  this.fOutputScope = null;
    super();
    this.fPostAction = null;
    this.fXMLFileName = null;

    this.fContentValue = "multipart/form-data";
    this.fContentDisp = "Content-Disposition";
    this.fDispType = "form-data";
  }

  InitCreatePubDoc(
    callbackObj,
    docType //outputScope
  ) {
    this.fDocType = docType;

    var now = new Date();
    var ticks = now.getTime();
    var r = Math.floor(Math.random() * 100);

    this.fXMLFileName = ticks.toString() + "_" + r.toString();
    //  this.fOutputScope = outputScope;
    this.InitRemoteCall(callbackObj, "POST", false, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qcreatepubdoc";
  }

  GetXMLFileName() {
    return this.fXMLFileName;
  }

  SetPostAction(postAction) {
    this.fPostAction = postAction;
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    var failure = ParseExportFailure(r);
    var pubFile = "";

    if (failure == null) pubFile = r;

    callBackObj.PublishDocResult(failure, pubFile, this.fDocType, this.fPostAction); // this.fOutputScope,
  }
}
